import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { CardView, Spacer } from 'design-system';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { abbreviateNumber, getMarginStr, getPeriodKey } from '../utils/format';
import { FinancialsPeriod } from '../types';
import BarInfo from './BarInfo';
import StockFinancialCardInfoBadge from './StockFinancialCardInfoBadge';
import StockFinancialCardsHeader from './StockFinancialCardsHeader';
import Timeframe from './Timeframe';
const IncomeStatement = ({ assetId, selection }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const periodKey = getPeriodKey(selection);
    const incomeStatementData = useAppSelector((state) => state.stockInfoReducer.financials?.[assetId]?.[periodKey]?.income);
    const [state, setState] = useState([]);
    useEffect(() => {
        if (incomeStatementData?.length) {
            setSelectedIndex(0);
            setState(incomeStatementData);
        }
    }, [selection, incomeStatementData]);
    const colors = useColors();
    if (!state.length)
        return null;
    const isQuarterlySelected = selection === FinancialsPeriod.QUARTERLY && incomeStatementData;
    const data = state.map((eachData) => ({
        secondBarY: eachData.netIncome,
        firstBarY: eachData.totalRevenue,
        label: isQuarterlySelected
            ? `Q${eachData.fiscalQuarter} ${String(eachData.fiscalYear).slice(-2)}`
            : String(eachData.fiscalYear),
    }));
    return (<CardView withPadding>
      <StockFinancialCardsHeader title="Income statement" infoModalTitle="Income statement" infoModalDesc="Focuses on the company’s revenues and expenses during a particular period. Also known as a “profit and loss statement” or a “statement of revenue and expense”."/>
      <Spacer h={16}/>
      <StockFinancialCardInfoBadge title="Profit margin" info={getMarginStr(state[selectedIndex].totalRevenue, state[selectedIndex].netIncome)}/>
      <Spacer h={8}/>
      <Timeframe data={data} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} firstBarColor={colors.elements.brand} secondBarColor={colors.gradients.darkPink.colors[0]}/>
      <Spacer h={16}/>
      <View style={styles.barInfo}>
        <View style={styles.flex2}>
          <BarInfo title="Revenue" color={colors.elements.brand} metrics={abbreviateNumber(state[selectedIndex].totalRevenue)}/>
        </View>
        <View style={styles.flex3}>
          <BarInfo title="Net Income" color={colors.gradients.darkPink.colors[0]} metrics={abbreviateNumber(state[selectedIndex].netIncome)}/>
        </View>
      </View>
    </CardView>);
};
export default IncomeStatement;
const styles = StyleSheet.create({
    barInfo: {
        flexDirection: 'row',
    },
    flex2: {
        flex: 2,
    },
    flex3: {
        flex: 3,
    },
});
